import styled, { css, createGlobalStyle } from 'styled-components';

export const FreecodePageBackground = styled.div`
  height: 100%;
  width: 100%;
  font-weight: 500;
  background: ${({ theme }) => theme.pageBackground};
`;

export const FreecodePageContentContainer = styled.div`
  padding-top: 55px;
  height: 100%;
  width: 100%;
`;

const scrollStyles = css`
  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.freecode.activeAreaBackgroundColor} !important;
  }
  ::-webkit-scrollbar {
    background: ${({ theme }) => theme.freecode.activeAreaBackgroundColor} !important;
    width: 8px !important;
  }
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.freecode.scrollBarColor} !important;
    border-radius: 3px;
  }
`;

export const GlobalStyle = createGlobalStyle`
  ${scrollStyles}
`;
